import * as React from "react";
import "../Styles/style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import UserDetails from "../ads/userDetails";
import MyadsNavigation from "../ads/myads-navigation";
import { Alert, Paper, Snackbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import InputMask from "react-input-mask";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Box } from "@mui/material";
import Lottie from "lottie-react";
import InReview from "../../images/doc-in-review.json";
import LoadingModal from "../modals/loading-modal";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function AddDealerProfile() {
  const [loading, setLoading] = useState(false);
  const [fullName, setFullName] = useState("");
  const [showRoomName, setShowRoomName] = useState("");
  const [showRoomContact, setShowRoomContact] = useState(null);
  const [logo, setLogo] = useState(null);
  const [cover, setCover] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dob, setDOB] = useState(null);
  const [city, setCity] = useState(null);
  const [user, setUser] = useState(null);
  const [cnicNumber, setCnicNumber] = useState(null);
  const [cities, setCities] = useState(null);
  const [address, setAddress] = useState(null);
  const [success, setSuccess] = useState(false);
  const [urlToken, setUrlToken] = useState(null);

  const [frontPicCnic, setFrontPicCninc] = useState(null);
  const [backPicCnic, setBackPicCninc] = useState(null);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [openError, setOpenError] = useState(false);

  const [error, setError] = useState("");

  const history = useHistory();

  const token = localStorage.getItem("token");

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${baseUrl}/getUser`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDOB(response?.data?.user_dob);
      setCity(response?.data?.city_id);
      setPhone(response?.data?.phone);
      setCnicNumber(response?.data?.cnic);
      setEmail(response?.data?.email);
      setFullName(response?.data?.name);
      setUser(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCity = async () => {
    try {
      const response = await axios.get(`${baseUrl}/cities`);

      setCities(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCity();
    fetchUser();
  }, []);

  useEffect(() => {
    const handleUrlChange = () => {
      const url = window.location.href;
      const parts = url.split("?");
      setUrlToken(parts[1] || null);
    };

    handleUrlChange();

    const unlisten = history.listen(() => {
      handleUrlChange();
    });

    return () => {
      unlisten();
    };
  }, [history]);

  const UserSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();

      formData.append("name", fullName);
      formData.append("address", city);
      formData.append("CNIC", cnicNumber);
      formData.append("phone", phone);
      formData.append("CNICFrontImage", frontPicCnic);
      formData.append("CNICBackImage", backPicCnic);

      const response = await axios.put(
        `${baseUrl}/fame/uploadDocuments/${user?.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      history.push(`/`);
      console.log(response.data, "inspection response");
    } catch (err) {
      console.error(err.response);
    }
  };

  const handleLogoChange = (e) => {
    if (e.target.files.length > 0) {
      setLogo(e.target.files[0]);
    } else {
      setLogo(null);
    }
  };

  const handleCoverChange = (e) => {
    if (e.target.files.length > 0) {
      setCover(e.target.files[0]);
    } else {
      setCover(null);
    }
  };

  const submitDealer = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("user_name", fullName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("showroom_name", showRoomName);
      formData.append("showroom_no", showRoomContact);
      formData.append("showroom_address", address);
      formData.append("city_id", city);
      formData.append("showroom_cover", cover);
      formData.append("showroom_logo", logo);
      formData.append("user_id", user?.id);

      const response = await axios.post(`${baseUrl}/becomedealer`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.data) {
        setSuccess(true);
        window.location.reload();
      }
    } catch (error) {
      console.log(error?.response?.data?.error);
      setOpenError(true);
      setError(error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingModal open={loading} onClose={() => setLoading(false)} />

      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Dealer Saved Successfully
        </Alert>
      </Snackbar>

      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSuccess(false)}
          severity="error"
          sx={{ width: "100%", backgroundColor: "#20409a", color: "#ffffff" }}
        >
          {error}
        </Alert>
      </Snackbar>

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <Lottie
            style={{ height: 250 }}
            animationData={InReview}
            loop={false}
          />
          <h3 className="fw-700">Verification In Process</h3>
          <p>Redirecting... </p>
        </Box>
      </Modal>

      {/* success modal */}
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              <div className="MyAdsArea_main ">
                <Paper
                  className="p-3"
                  sx={{ width: "100%", overflow: "hidden" }}
                >
                  <div className="container mt-3 pb-3">
                    <h4 className="fw-600 mb-3">Personal Info</h4>
                    <form className="postAdForm" onSubmit={submitDealer}>
                      <div className="row mb-3">
                        <div className="col-6">
                          <label for="post-title" className="form-label">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="post-title"
                            aria-describedby="titleHelp"
                            required
                            placeholder="Full Name"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                          />
                        </div>
                        <div className="col-6">
                          <label for="post-title" className="form-label">
                            Email
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="post-title"
                            aria-describedby="titleHelp"
                            required
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-6">
                          <label for="post-title" className="form-label">
                            Phone
                          </label>
                          <InputMask
                            mask="03999999999"
                            maskChar={null}
                            type="text"
                            className="form-control"
                            iid="post-phone"
                            placeholder="03xxxxxxxxx"
                            required
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                        <div className="col-6">
                          <label for="post-title" className="form-label">
                            City
                          </label>
                          <select
                            className="form-select"
                            id="post-registeration"
                            aria-label="Default select example"
                            placeholder="City"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          >
                            <option selected value="">
                              Select City
                            </option>
                            {cities &&
                              cities.map((item) => (
                                <option key={item.cityID} value={item.cityID}>
                                  {item.cityName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-12">
                          <h4 className="fw-600 my-3">Showroom Info</h4>
                        </div>
                        <div className="col-6 mb-3">
                          <label for="post-title" className="form-label">
                            Showroom Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="post-title"
                            aria-describedby="titleHelp"
                            required
                            placeholder="Showroom Name"
                            value={showRoomName}
                            onChange={(e) => setShowRoomName(e.target.value)}
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <label for="post-title" className="form-label">
                            Contact
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="post-title"
                            aria-describedby="titleHelp"
                            required
                            placeholder="Contact"
                            value={showRoomContact}
                            onChange={(e) => setShowRoomContact(e.target.value)}
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <label for="post-title" className="form-label">
                            Address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="post-title"
                            aria-describedby="titleHelp"
                            required
                            placeholder="Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <label for="post-logo" className="form-label">
                            Logo
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="post-logo"
                            aria-describedby="titleHelp"
                            onChange={handleLogoChange}
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <label for="post-cover" className="form-label">
                            Cover Photo
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="post-cover"
                            aria-describedby="titleHelp"
                            onChange={handleCoverChange}
                          />
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn bgSecondary color-white model_loginBTn my-3 px-4 py-1 fw-500 fs-5 "
                        >
                          Continue
                        </button>
                      </div>
                    </form>
                  </div>
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
